import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index'
import login from '@/pages/login/index'
import mine from '@/pages/mine/index'
import enroll from '@/pages/enroll/index'
import invoiceList from '@/pages/invoiceList/index'
import individualList from '@/pages/individualList/index'
import individualDetails from '@/pages/individualDetails/index'
import legalPerson from '@/pages/legalPerson/index'
import legalPersonTwo from '@/pages/legalPersonTwo/index'
import legalPersonThree from '@/pages/legalPersonThree/index'
import orderDetails from '@/pages/orderDetails/index'
import orderList from '@/pages/orderList/index'
import transferList from '@/pages/transferList/index'
import camera from '@/pages/camera/index'
// 头部通用步骤条
import commonInfo from '@/pages/commonInfo/index'
// 注册页面（引导页）
import register from '@/pages/register/index'
// 更多操作
import moreInfo from '@/pages/moreInfo/index'
// 上传身份证
import uploadCard from '@/pages/uploadCard/index'
// 我的钱包
import myWallet from '@/pages/wallet/myWallet/index'
// 提现
import checkDetail from '@/pages/wallet/checkDetail/index'
// 1.H5实名认证资料校验
import realNameLoading from '@/pages/entryFile/realNameLoading/index'
// 2.H5开通二类户资料校验
import secondClassLoading from '@/pages/entryFile/secondClassLoading/index'
// 3.H5我的钱包资料校验
import myWalletLoading from '@/pages/entryFile/myWalletLoading/index'
// 4.H5任务详情资料校验
import taskDetailLoading from '@/pages/entryFile/taskDetailLoading/index'
// 5.我的签约资料校验
import mySignLoading from '@/pages/entryFile/mySignLoading/index'
// 免登接单
import takeLoading from '@/pages/entryFile/takeLoading/index'
// 需要登录接单
import taskLoading from '@/pages/entryFile/taskLoading/index'
// 我的签约
import mySign from '@/pages/mySign/index'

import freeTreaty from '@/pages/treaty/freeTreaty/index'
import pinganTreaty from '@/pages/treaty/pinganTreaty/index'
import personTreaty from '@/pages/treaty/personTreaty/index'
// 我的个人中心
import updateInfo from '@/pages/updateInfo/index'
// 我的个人中心>我的信息
import myReal from '@/pages/myReal/index'
// 银行卡详情
import bankDetail from '@/pages/wallet/bankDetail/index'
// 余额明细查询
import detailQuery from '@/pages/wallet/detailQuery/index'
// 绑定银行卡
import bindBankCard from '@/pages/bindBankCard/index'
// 任务详情
import taskDetail from '@/pages/task/taskDetail/index'
// 申请成功
import applicationSuccess from '@/pages/task/applicationSuccess/index'
import noLogin from '@/pages/noLogin/index'
import withdrawStep from '@/pages/wallet/withdrawStep/index'
import applyAdmitTab from '@/pages/applyAdmit/applyAdmitTab/index'
import applyTabDetail from '@/pages/applyAdmit/applyTabDetail/index'
import workOrderTab from '@/pages/workOrder/workOrderTab/index'
import workOrderDetail from '@/pages/workOrder/workOrderDetail/index'
import dealOrderTab from '@/pages/dealOrder/dealOrderTab/index'
import aggreement_yz from '@/pages/agreement/aggreement_yz'
import aggreement_yz_merchant from '@/pages/agreement/aggreement_yz_merchant'
import aggreement_yz_merchantv1 from '@/pages/agreement/aggreement_yz_merchantv1'
import aggreement_yz_merchantv2 from '@/pages/agreement/aggreement_yz_merchantv2'
import aggreement_hc from '@/pages/agreement/aggreement_hc'

import aggreement_yz_merchant_template from '@/pages/agreement/aggreement_yz_merchant_template'
import aggreement_yz_merchant_notice from '@/pages/agreement/aggreement_yz_merchant_notice'

import agreement_sp_common from '@/pages/agreement/agreement_sp_common'
import agreement_sp_common_merchant from '@/pages/agreement/agreement_sp_common_merchant'

import agreement_personal_privacy from '@/pages/agreement/agreement_personal_privacy'
import agrement_company_privacy from '@/pages/agreement/agrement_company_privacy'

import memberContract from '@/pages/customiezd/member/sign'
import memberContractSuccess from '@/pages/customiezd/member/success'
import success_wx_ma_task from '@/pages/success/success_wx_ma_task'
import success_wx_ma_task_qqzs from '@/pages/success/success_wx_ma_task_qqzs'

// 灵活用工合伙人申请通道
import applyInfo from '@/pages/partner/applyInfo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'index',
    meta: {
      requireAuth: true // 配置此条，进入页面前判断是否需要登陆
    },
    component: index
  }, {
    path: '/login',
    name: 'login',
    meta: {
      requireAuth: true
    },
    component: login
  }, {
    path: '/mine',
    name: 'mine',
    meta: {
      requireAuth: true
    },
    component: mine
  }, {
    path: '/enroll',
    name: 'enroll',
    meta: {
      requireAuth: true
    },
    component: enroll
  }, {
    path: '/invoiceList',
    name: 'invoiceList',
    meta: {
      requireAuth: true
    },
    component: invoiceList
  }, {
    path: '/individualList',
    name: 'individualList',
    meta: {
      requireAuth: true
    },
    component: individualList
  }, {
    path: '/individualDetails',
    name: 'individualDetails',
    meta: {
      requireAuth: true
    },
    component: individualDetails
  }, {
    path: '/legalPerson',
    name: 'legalPerson',
    meta: {
      requireAuth: true
    },
    component: legalPerson
  }, {
    path: '/legalPersonTwo',
    name: 'legalPersonTwo',
    meta: {
      requireAuth: true
    },
    component: legalPersonTwo
  }, {
    path: '/legalPersonThree',
    name: 'legalPersonThree',
    meta: {
      requireAuth: true
    },
    component: legalPersonThree
  }, {
    path: '/orderDetails',
    name: 'orderDetails',
    meta: {
      requireAuth: true
    },
    component: orderDetails
  }, {
    path: '/orderList',
    name: 'orderList',
    meta: {
      requireAuth: true
    },
    component: orderList
  }, {
    path: '/transferList',
    name: 'transferList',
    meta: {
      requireAuth: true
    },
    component: transferList
  }, {
    path: '/register',
    name: 'register',
    meta: {
      requireAuth: true
    },
    component: register
  }, {
    path: '/moreInfo',
    name: 'moreInfo',
    meta: {
      requireAuth: true
    },
    component: moreInfo
  }, {
    path: '/uploadCard',
    name: 'uploadCard',
    meta: {
      requireAuth: true
    },
    component: uploadCard
  }, {
    path: '/commonInfo',
    name: 'commonInfo',
    meta: {
      requireAuth: true
    },
    component: commonInfo
  },
    {
      path: '/camera',
      name: 'camera',
      meta: {
        requireAuth: true
      },
      component: camera
    },
    {
      path: '/enroll',
      name: 'enroll',
      meta: {
        requireAuth: true
      },
      component: enroll
    },
    {
      path: '/myWallet',
      name: 'myWallet',
      meta: {
        requireAuth: true
      },
      component: myWallet
    },
    {
      path: '/checkDetail',
      name: 'checkDetail',
      meta: {
        requireAuth: true
      },
      component: checkDetail
    },
    {
      path: '/realNameLoading',
      name: 'realNameLoading',
      meta: {
        requireAuth: true
      },
      component: realNameLoading
    },
    {
      path: '/secondClassLoading',
      name: 'secondClassLoading',
      meta: {
        requireAuth: true
      },
      component: secondClassLoading
    },
    // ?phone=13520557836&userName=wangqing&idNo=1231231313123123123
    {
      path: '/freeTreaty',
      name: 'freeTreaty',
      meta: {
        requireAuth: true
      },
      component: freeTreaty
    },
    {
      path: '/pinganTreaty',
      name: 'pinganTreaty',
      meta: {
        requireAuth: true
      },
      component: pinganTreaty
    },
    {
      path: '/personTreaty',
      name: 'personTreaty',
      meta: {
        requireAuth: true
      },
      component: personTreaty
    },
    {
      path: '/updateInfo',
      name: 'updateInfo',
      meta: {
        requireAuth: true
      },
      component: updateInfo
    },
    {
      path: '/myReal',
      name: 'myReal',
      meta: {
        requireAuth: true
      },
      component: myReal
    },
    // 银行卡详情
    {
      path: '/bankDetail',
      name: 'bankDetail',
      meta: {
        requireAuth: true
      },
      component: bankDetail
    },
    // 余额明细查询
    {
      path: '/detailQuery',
      name: 'detailQuery',
      meta: {
        requireAuth: true
      },
      component: detailQuery
    },
    // 绑定银行卡
    {
      path: '/bindBankCard',
      name: 'bindBankCard',
      meta: {
        requireAuth: true
      },
      component: bindBankCard
    },
    // 任务详情
    {
      path: '/taskDetail',
      name: 'taskDetail',
      meta: {
        requireAuth: true
      },
      component: taskDetail
    },
    // 申请成功页面
    {
      path: '/applicationSuccess',
      name: 'applicationSuccess',
      meta: {
        requireAuth: true
      },
      component: applicationSuccess
    },
    {
      path: '/myWalletLoading',
      name: 'myWalletLoading',
      meta: {
        requireAuth: true
      },
      component: myWalletLoading
    },
    {
      path: '/taskDetailLoading',
      name: 'taskDetailLoading',
      meta: {
        requireAuth: true
      },
      component: taskDetailLoading
    },
    {
      path: '/mySignLoading',
      name: 'mySignLoading',
      meta: {
        requireAuth: true
      },
      component: mySignLoading
    },
    {
      path: '/mySign',
      name: 'mySign',
      meta: {
        requireAuth: true
      },
      component: mySign
    },
    {
      path: '/noLogin',
      name: 'noLogin',
      meta: {
        requireAuth: true
      },
      component: noLogin
    },
    // 免登接单
    {
      path: '/takeLoading',
      name: 'takeLoading',
      meta: {
        requireAuth: true
      },
      component: takeLoading
    },
    // 需要登录接单
    {
      path: '/taskLoading',
      name: 'taskLoading',
      meta: {
        requireAuth: true
      },
      component: taskLoading
    },
    {
      path: '/withdrawStep',
      name: 'withdrawStep',
      meta: {
        requireAuth: true
      },
      component: withdrawStep
    },
    {
      path: '/applyAdmitTab',
      name: 'applyAdmitTab',
      meta: {
        requireAuth: true
      },
      component: applyAdmitTab
    },
    {
      path: '/applyTabDetail',
      name: 'applyTabDetail',
      meta: {
        requireAuth: true
      },
      component: applyTabDetail
    },
    {
      path: '/workOrderTab',
      name: 'workOrderTab',
      meta: {
        requireAuth: true
      },
      component: workOrderTab
    },
    {
      path: '/workOrderDetail',
      name: 'workOrderDetail',
      meta: {
        requireAuth: true
      },
      component: workOrderDetail
    },
    {
      path: '/dealOrderTab',
      name: 'dealOrderTab',
      meta: {
        requireAuth: true
      },
      component: dealOrderTab
    },
    {
      path: '/aggreement_yz',
      name: 'aggreement_yz',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz
    },
    {
      path: '/aggreement_yz.html',
      name: 'aggreement_yz',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz
    },
    {
      path: '/aggreement_yz_merchant',
      name: 'aggreement_yz_merchant',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchant
    },
    {
      path: '/aggreement_yz_merchant.html',
      name: 'aggreement_yz_merchant',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchant
    },
    {
      path: '/aggreement_yz_merchantv1',
      name: 'aggreement_yz_merchantv1',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchantv1
    },
    {
      path: '/aggreement_yz_merchantv1.html',
      name: 'aggreement_yz_merchantv1',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchantv1
    },
    {
      path: '/aggreement_yz_merchantv2',
      name: 'aggreement_yz_merchantv2',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchantv2
    },
    {
      path: '/aggreement_yz_merchantv2.html',
      name: 'aggreement_yz_merchantv2',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchantv2
    },

    //region 公告与协议模板
    {
      path: '/aggreement_yz_merchant_template',
      name: 'aggreement_yz_merchant_template',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchant_template
    },
    {
      path: '/aggreement_yz_merchant_template.html',
      name: 'aggreement_yz_merchant_template',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchant_template
    },
    //endregion

    //region 公告
    {
      path: '/aggreement_yz_merchant_notice',
      name: 'aggreement_yz_merchant_notice',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchant_notice
    },
    {
      path: '/aggreement_yz_merchant_notice.html',
      name: 'aggreement_yz_merchant_notice',
      meta: {
        requireAuth: true
      },
      component: aggreement_yz_merchant_notice
    },
    //endregion

    {
      path: '/hc_aggreement',
      name: 'aggreement_hc',
      meta: {
        requireAuth: true
      },
      component: aggreement_hc
    },
    {
      path: '/hc_aggreement.html',
      name: 'aggreement_hc',
      meta: {
        requireAuth: true
      },
      component: aggreement_hc
    },
    {
      path: '/agreement_sp_common.html',
      name: 'agreement_sp_common',
      meta: {
        requireAuth: true
      },
      component: agreement_sp_common
    },
    {
      path: '/agreement_sp_common_merchant.html',
      name: 'agreement_sp_common_merchant',
      meta: {
        requireAuth: true
      },
      component: agreement_sp_common_merchant
    },
    {
      path: '/agreement_personal_privacy.html',
      name: 'agreement_personal_privacy',
      meta: {
        requireAuth: true
      },
      component: agreement_personal_privacy
    },
    {
      path: '/agreement_personal_privacy',
      name: 'agreement_personal_privacy',
      meta: {
        requireAuth: true
      },
      component: agreement_personal_privacy
    },
    {
      path: '/agrement_company_privacy.html',
      name: 'agrement_company_privacy',
      meta: {
        requireAuth: true
      },
      component: agrement_company_privacy
    },
    {
      path: '/agrement_company_privacy',
      name: 'agrement_company_privacy',
      meta: {
        requireAuth: true
      },
      component: agrement_company_privacy
    },

    {
      path: '/memberContract',
      name: 'memberContract',
      meta: {
        requireAuth: true
      },
      component: memberContract
    },
    {
      path: '/memberContractSuccess',
      name: 'memberContractSuccess',
      meta: {
        requireAuth: true
      },
      component: memberContractSuccess
    },
    {
      path: '/success_wx_ma_task',
      name: 'success_wx_ma_task',
      meta: {
        requireAuth: true
      },
      component: success_wx_ma_task
    },
    {
      path: '/successcasewxmatask',
      name: 'success_wx_ma_task',
      component: success_wx_ma_task
    },
    {
      path: '/successcasewxmataskqqzs',
      name: 'success_wx_ma_task_qqzs',
      component: success_wx_ma_task_qqzs
    },
    // 灵活用工合伙人申请通道
    {
      path: '/applyInfo',
      name: 'applyInfo',
      component: applyInfo
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js